import { render, staticRenderFns } from "./TelegramInvitationInstructions.vue?vue&type=template&id=065921da&scoped=true&"
import script from "./TelegramInvitationInstructions.vue?vue&type=script&lang=js&"
export * from "./TelegramInvitationInstructions.vue?vue&type=script&lang=js&"
import style0 from "./TelegramInvitationInstructions.vue?vue&type=style&index=0&id=065921da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065921da",
  null
  
)

export default component.exports